var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.03577 15.3878C4.00877 15.7358 4.25177 16.0258 4.57577 16.0258H6.03377C6.35777 16.0258 6.62777 15.7358 6.62777 15.3878C6.62777 15.0398 6.35777 14.7498 6.03377 14.7498H4.62977C4.27877 14.7498 4.03577 15.0398 4.03577 15.3878Z",
    fill: "url(#paint0_linear_2480_7436)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2428 16.0258C12.8918 16.0258 12.6218 15.7358 12.6218 15.3878C12.6218 15.0398 12.8918 14.7498 13.2428 14.7498H14.6468C14.8358 14.7498 14.9978 14.8368 15.1058 14.9528C15.2138 15.0688 15.2678 15.2138 15.2678 15.3878C15.2408 15.7358 14.9978 16.0258 14.6468 16.0258H13.2428Z",
    fill: "url(#paint1_linear_2480_7436)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2158 11.3858H14.6738C14.9978 11.3858 15.2678 11.0958 15.2678 10.7478C15.2678 10.3998 14.9978 10.1098 14.6738 10.1098H13.2698C12.9458 10.1098 12.6758 10.3998 12.6758 10.7478C12.6218 11.0958 12.8918 11.3858 13.2158 11.3858Z",
    fill: "url(#paint2_linear_2480_7436)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.60277 11.3858C4.25177 11.3858 3.98177 11.0958 4.00877 10.7478C4.00877 10.3998 4.27877 10.1098 4.60277 10.1098H6.00677C6.33077 10.1098 6.60077 10.3998 6.60077 10.7478C6.60077 11.0958 6.35777 11.3858 6.00677 11.3858H4.60277Z",
    fill: "url(#paint3_linear_2480_7436)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92277 11.3858H10.2998C10.6508 11.3858 10.9208 11.1248 10.9208 10.7478C10.9208 10.3998 10.6508 10.1098 10.2998 10.1098H8.89577C8.54477 10.1098 8.30177 10.3708 8.27477 10.7478C8.30177 11.0958 8.57177 11.3858 8.92277 11.3858Z",
    fill: "url(#paint4_linear_2480_7436)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3538 16.0258H8.86877C8.54477 15.9968 8.30177 15.7358 8.27477 15.3878C8.27477 15.0398 8.54477 14.7498 8.86877 14.7498H10.3268C10.6508 14.7788 10.9208 15.0398 10.9208 15.3878C10.9208 15.7358 10.6778 16.0258 10.3538 16.0258Z",
    fill: "url(#paint5_linear_2480_7436)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7238 4.36781C18.2918 2.71481 16.9688 1.61281 15.2948 1.61281H14.5388V0.916806C14.5658 0.481806 14.4308 0.220806 14.0528 0.0758057H13.8098C13.4588 0.220806 13.2968 0.481806 13.3238 0.945806V1.64181H5.89877V0.945806C5.92577 0.510806 5.79077 0.220806 5.41277 0.0758057H5.16977C4.81877 0.220806 4.65677 0.481806 4.68377 0.916806V1.64181H3.49577C1.95677 1.75781 0.55277 3.17881 0.39077 4.80281C0.36377 5.03481 0.36377 5.20881 0.36377 5.35381V16.1128C0.36377 17.8818 1.49777 19.3898 3.09077 19.7668C3.33377 19.8248 3.60377 19.8538 3.90077 19.8538H15.2408C17.0498 19.8538 18.5078 18.5198 18.7508 16.5768C18.7508 16.5623 18.7575 16.5478 18.7643 16.5333C18.771 16.5188 18.7778 16.5043 18.7778 16.4898V4.94781L18.8048 4.77381C18.7778 4.65781 18.7508 4.51281 18.7238 4.36781ZM17.6438 16.0548C17.6438 17.5338 16.6448 18.5778 15.2948 18.6068H3.95477C2.57777 18.6068 1.60577 17.5338 1.60577 16.0548V7.52881H17.6708L17.6438 16.0548ZM17.6438 6.10781L17.6168 6.22381H1.63277L1.60577 6.10781C1.47077 5.12181 1.68677 4.22281 2.22677 3.64281C2.76677 3.03381 3.57677 2.77281 4.57577 2.91781H4.68377V4.54181C4.68377 4.91881 4.92677 5.17981 5.27777 5.17981C5.62877 5.17981 5.87177 4.91881 5.87177 4.54181V3.03381L5.89877 2.91781L6.00677 2.88881H13.2968V4.57081C13.2968 4.94781 13.5668 5.20881 13.8908 5.20881C14.2148 5.20881 14.4578 4.91881 14.4848 4.57081V2.94681L14.5928 2.91781C15.5918 2.80181 16.4018 3.03381 16.9418 3.64281C17.5358 4.19381 17.7518 5.09281 17.6438 6.10781Z",
    fill: "url(#paint6_linear_2480_7436)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2480_7436",
    x1: 9.58427,
    y1: 0.0758057,
    x2: 9.58427,
    y2: 19.8538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6984FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8549FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2480_7436",
    x1: 9.58427,
    y1: 0.0758057,
    x2: 9.58427,
    y2: 19.8538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6984FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8549FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2480_7436",
    x1: 9.58427,
    y1: 0.0758057,
    x2: 9.58427,
    y2: 19.8538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6984FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8549FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2480_7436",
    x1: 9.58427,
    y1: 0.0758057,
    x2: 9.58427,
    y2: 19.8538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6984FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8549FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2480_7436",
    x1: 9.58427,
    y1: 0.0758057,
    x2: 9.58427,
    y2: 19.8538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6984FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8549FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2480_7436",
    x1: 9.58427,
    y1: 0.0758057,
    x2: 9.58427,
    y2: 19.8538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6984FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8549FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2480_7436",
    x1: 9.58427,
    y1: 0.0758057,
    x2: 9.58427,
    y2: 19.8538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6984FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8549FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarBlue);
export default __webpack_public_path__ + "static/media/calendar_blue.c7b6fb7ee1f4c4aeb679cc6efc3d57f7.svg";
export { ForwardRef as ReactComponent };